import { useHasReadLinePermission } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";

import {
  getNumberSettingsRoute,
  redirectToDashboard,
} from "@/helpers/navigation/navigation.helpers";
import { useGetLine } from "../useGetLine/useGetLine";

const noop = () => {};

export function useUpdateLineSettings() {
  const { line } = useGetLine();

  const hasReadLinePermission = useHasReadLinePermission();

  if (!line || !hasReadLinePermission) {
    return noop;
  }

  return () => {
    redirectToDashboard(getNumberSettingsRoute(line.ID));
  };
}
